import {observer} from "mobx-react";
import {Linq, Page, Pager, ScrollTable, Searchbar} from "../../ui";
import {PageContentTitle} from "@kroschke/react-ui";
import {useNavigate, useSearchParams} from "react-router";
import {useEffect} from "react";
import {pageQueryStore, vhsListStore} from "../../../store";
import {VhsFilterBar} from "./VhsFilterBar";
import {VehicleItemDto} from "../../../api/vhs";


function displayCustomer(v: VehicleItemDto): string | undefined {
    const {customer} = v
    if (!customer) {
        return v.customerId
    }
    return `${customer.displayName} (${customer.customerNumber})`
}

const VhsOverviewPage = observer(function VhsOverviewPage() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        pageQueryStore.restore('vhs', searchParams, setSearchParams)
    }, [searchParams, setSearchParams])

    return <Page
        cssSuffix={"vhs-overview"}
        breadcrumb={[
            {
                link: '/vhs',
                label: `Fahrzeughistorie`
            }
        ]}
    >
        <PageContentTitle
            actionItem={<>
                <VhsFilterBar/>
            </>}
        >
            <Searchbar placeholder={"FIN"}/>
        </PageContentTitle>

        <ScrollTable>
            <thead>
            <tr>
                <th>Fahrzeug</th>
                <th>Kunde</th>
            </tr>
            </thead>
            <tbody>
            {vhsListStore.items.map((val, index) => {
                const link = `/vhs/${val.customerId}/${val.vin}`
                return <tr key={index} onClick={() => {navigate(link)}}>
                    <td><Linq to={`${link}`}>{val.vin}</Linq></td>
                    <td><Linq to={`${link}`}>{displayCustomer(val)}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={vhsListStore.pages} />
    </Page>
})

export {
    VhsOverviewPage
}
